import name from './mutationsName';

export default {
  [name.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [name.SET_NEWS_COUNT](state, newsCount) {
    state.newsCount = newsCount;
  },
  [name.SET_TASK_INFO](state, taskInfo) {
    state.taskInfo = taskInfo;
  },
  [name.Set_Head_Action](state, headAction) {
    state.headAction = headAction;
  },
  [name.Set_Left_Action](state, leftAction) {
    state.leftAction = leftAction;
  },
  [name.Set_Behavior_Body_Add](state, behaviorBody) {
    state.behaviorBody.push(behaviorBody);
  },
  [name.Set_Behavior_Body_Del](state, index) {
    state.behaviorBody.splice(0, index);
  },
};
